import { format } from 'date-fns';
import {
  externalOr,
  logStatusDisplay,
} from 'src/app/shared/flight-log-api/flight-logs/flight-log-client-model-helpers';
import {
  LogMode,
  LogStatus,
} from 'src/app/shared/flight-log-api/flight-logs/flight-log-client.model';
import { FlightOutcome } from 'src/app/shared/flight-log-api/flights/flight-client.model';
import {
  FlightStatus,
  FlightType,
  flightTypeDisplay,
} from 'src/app/shared/flight-log-api/shared/shared-client.model';
import { AircraftEntity } from 'src/store/aircraft/aircraft.model';
import { BaseEntity } from 'src/store/base/base.model';
import { CompanyEntity } from 'src/store/company/company.model';
import { FlightLogHighlightsCommonProps } from 'src/store/flight-log/flight-log.model';
import { humanize } from 'src/util/text';

class FlightLogHighlightsViewModelBase implements FlightLogHighlightsCommonProps {
  private readonly _jsonValue: any;
  public id: string;
  public flightSummaryId?: string;
  public companyId?: string;
  public baseId?: string;
  public aircraftId?: string;
  public status: LogStatus;
  public mode: LogMode;
  public flightType?: FlightType;
  public flightTagNumber?: string;
  public flightTime?: Date;
  public updatedBy?: string;
  public comment?: string;
  public deletedAt?: Date;
  public fromLocation?: string;
  public toLocation?: string;
  constructor(props: FlightLogHighlightsCommonProps) {
    this._jsonValue = props;
    Object.assign(this, props);
  }

  get flightSummaryIdDisplay() {
    return externalOr(this.mode, this.flightSummaryId);
  }

  get logStatusDisplay() {
    return logStatusDisplay(this.status);
  }
  get flightTypeDisplay() {
    return this.flightType != null ? flightTypeDisplay(this.flightType) : 'Unknown';
  }
  get flightTagNumberDisplay() {
    return externalOr(this.mode, this.flightTagNumber != null ? this.flightTagNumber : null);
  }

  public toJSON() {
    return this._jsonValue;
  }
}
export class FlightLogHighlightsViewModel
  extends FlightLogHighlightsViewModelBase
  implements FlightLogHighlightsCommonProps
{
  public pilotName?: string;
  public pilotEmployeeId?: string;
  public coPilotEmployeeId?: string;
  public isUnassigned: boolean;
  public dispatchId?: string;
  public dateOfService?: Date;
  public flightStatus: FlightStatus;
  public flightOutcome: FlightOutcome;
  public programId?: string;
  public aircraft?: AircraftEntity;
  public company?: CompanyEntity;
  public transportBase?: BaseEntity;

  constructor(flightLogHighlights: FlightLogHighlightsCommonProps) {
    super(flightLogHighlights);
    Object.assign(this, flightLogHighlights);
  }

  get effectiveDateOfService(): Date | null | undefined {
    return this.flightTime != null ? this.flightTime : this.dateOfService;
  }

  get dateofServiceDisplay(): string | undefined {
    return this.effectiveDateOfService != null
      ? format(this.effectiveDateOfService, 'MM/DD/YYYY HH:mm')
      : undefined;
  }

  get tailNumberDisplay() {
    return externalOr(this.mode, this.aircraft != null ? this.aircraft.tailNumber : null);
  }

  get flightStatusDisplay() {
    return this.flightStatus != null ? humanize(this.flightStatus) : 'Unknown';
  }

  public static fromJS(flightLog: FlightLogHighlightsCommonProps): FlightLogHighlightsViewModel {
    if (flightLog instanceof FlightLogHighlightsViewModel) {
      return flightLog;
    }
    return new FlightLogHighlightsViewModel(flightLog);
  }
}
